import { stringify } from 'qs'
import { useGlobalState } from 'context/GlobalStateContext'
import AnchorButton from '../AnchorButton'
import { CSVButtonProps } from './types'

const CSVButton: React.VFC<CSVButtonProps> = ({
  entity,
  label = 'CSV Export',
  primary,
}) => {
  const {
    state: { projectGlobalId },
  } = useGlobalState()
  const url = `${
    process.env.REACT_APP_BACK_END_URL
  }/api/projects/${projectGlobalId}/csv?${stringify(
    { entity: entity.queryParameter },
    { encode: true }
  )}`
  return (
    <AnchorButton type={primary ? 'primary' : undefined} href={url}>
      {label}
    </AnchorButton>
  )
}

export default CSVButton
